<template>
  <div>
    <input type="text"
      class="input"
      ref="input"
      :placeholder="placeholder"
      autocomplete="off"
      v-model="query"
      @keydown.down="down"
      @keydown.up="up"
      @keydown.enter="hit"
      @keydown.esc="reset"
      @input="update"
      @blur="onBlur"
      @focus="onFocus">
    <ul v-show="hasItems && focus">
      <li v-for="(item, $item) in items" :class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
        <span class="screen-name" v-text="item"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import VueTypeahead from 'vue-typeahead';

export default {
  extends: VueTypeahead,
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      focus: false,
      value: '',
    };
  },
  methods: {
    onFocus() {
      this.focus = true;
    },
    onBlur() {
      this.focus = false;
    },
    onHit(item) {
      this.query = item;
      this.$refs.input.blur();
    },
    fetch() {
      return Promise.resolve({
        data: this.values.filter(item =>
          item.toLowerCase().includes(this.query.toLowerCase()),
        ),
      });
    },
  },
  computed: {
    isEmpty() {
      return false;
    },
  },
  watch: {
    values(newValues) {
      this.items = newValues;
    },
    query(newQuery) {
      if (!newQuery.length) {
        this.items = this.values;
      }
      this.value = newQuery;
      this.$emit('input', this.value);
    },
  },
};
</script>

<style scoped>
  i {
    float: right;
    position: relative;
    top: 30px;
    right: 29px;
    opacity: 0.4;
  }
  ul {
    position: absolute;
    padding: 0;
    margin-top: 8px;
    min-width: 100%;
    background-color: #fff;
    list-style: none;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0,0,0, 0.25);
    z-index: 10;
  }
  li {
    padding: 10px 16px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
  }
  li:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  li:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom: 0;
  }
  span {
    display: block;
    color: #2c3e50;
  }
  .active {
    background-color: #3aa373;
  }
  .active span {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// Typeahead.vue?7fc157d7